import { ProtectedRoute as ProtectedRouteView } from './ProtectedRoute.view';
export * from './ProtectedRoute.view';

export const ProtectedRoute = (props) => ProtectedRouteView(props);

export default ProtectedRoute;

